module.exports = "/assets/data/1a58b3263e0e17ba2646470348e27d47-BH3.data.json";